import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { LoginForm } from "../components/LoginForm";

export function LoginPage() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/");
  };

  const handleSwitchToRegister = () => {
    navigate("/register");
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: "var(--color-background)" }}
    >
      <div className="w-full max-w-md">
        <div
          className="p-8 rounded-neo-none"
          style={{
            backgroundColor: "var(--color-surface)",
            border: "6px solid var(--color-text-primary)",
            borderRadius: 0,
            boxShadow: "12px 12px 0px rgba(0, 0, 0, 0.2)",
            position: "relative",
          }}
        >
          {/* Top accent bar */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "6px",
              background: `linear-gradient(90deg, var(--color-primary), var(--color-secondary), var(--color-accent))`,
              borderRadius: 0,
            }}
          />

          <div className="flex items-center justify-between mb-8 pt-2">
            <h1
              className="font-display text-3xl font-black"
              style={{ color: "var(--color-text-primary)", margin: 0 }}
            >
              Sign In
            </h1>
            <Button
              variant="secondary"
              className="text-sm px-3 py-1"
              onClick={handleBack}
            >
              Back
            </Button>
          </div>
          <LoginForm
            onSuccess={handleSuccess}
            onSwitchToRegister={handleSwitchToRegister}
          />
        </div>
      </div>
    </div>
  );
}
